<template>

    <li class="dd-m-card dd-m-card--light-content">
        <div class="dd-m-card--light-content__description">
            {{item.review}}
        </div>
    </li>

</template>
<script>
    export default {
        name: 'card-light-content',
        props: ['item'],
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-light-content.vue